import useTwBreakpoint from "common/hooks/useTwBreakpoint";
import type { LeadsSearchParams, SelectedFacetParam } from "common/types";

import DesktopLayout from "./DesktopLayout";
import MobileLayout from "./MobileLayout";

export default function FavoriteFilter({
  searchParams,
  setSearchParams,
}: {
  searchParams: LeadsSearchParams<SelectedFacetParam>;
  setSearchParams: (
    searchParams: Partial<LeadsSearchParams<SelectedFacetParam>>,
  ) => void;
}) {
  const isDesktop = useTwBreakpoint("lg");

  function setFilter(newValue: boolean) {
    setSearchParams({ favorite: newValue });
  }

  const Component = isDesktop ? DesktopLayout : MobileLayout;
  return <Component isFavorite={searchParams.favorite} setFilter={setFilter} />;
}
